import Vue from "vue";
import VueMaterial from "vue-material";

import VueMaterialPatch from "lib/plugins/VueMaterialPatch";
import Notification from "lib/components/Notification";
import cookie from "lib/modules/Cookie";

window.$bus = new Vue();

Vue.use(VueMaterial);
Vue.use(VueMaterialPatch);

new Vue({
	el: "#notification",
	mounted() {
		cookie.checkConsent();
	},
	render(h) {
		return h(Notification);
	}
});
